import { Box, Divider, Stack, Text, Image } from '@chakra-ui/react';
import { Container } from '../layout';
import Logo from '../logo';
import { BiLogoInstagram, BiLogoTelegram } from 'react-icons/bi';
import { FaLocationDot, FaMobile } from 'react-icons/fa6';
import { Link } from 'react-router-dom';
import { FaCheckDouble } from 'react-icons/fa6';

function Footer() {
  return (
    <footer>
      <Container bgColor={'gray.50'} textAlign={'center'} mt={4}>
        <Stack
          align={'center'}
          justify={'center'}
          minHeight={{ md: '287px' }}
          py={4}
          spacing={6}
        >
          <Logo />
          <Stack direction={{ base: 'column-reverse', md: 'column' }}>
            <Text
              fontSize={{ base: '12px', md: 'md' }}
              color={'blackAlpha.700'}
            >
              با افتخار ارائه دهنده مدرن ترین راهکارها در صنعت چاپ و تبلیغات
              برای شما عزیزان هستیم. <br />
              ما معتقدیم که شما شایسته برترین ها هستید.
            </Text>
          </Stack>
          <Divider w="100%" />
          <Stack
            w="100%"
            direction={{ base: 'column', lg: 'row' }}
            align={'center'}
            justify={'center'}
            spacing={{ base: 6, lg: 12 }}
          >
            <Stack>
              <InfoItem
                icon={FaLocationDot}
                title="آدرس :"
                value="مجیدیه ۱۷، مرشدلو ۱، ساختمان پارسا"
              />

              <InfoItem
                icon={FaMobile}
                title="تلفن پشتیبانی:"
                value={
                  <Stack textAlign={'right'}>
                    <a href={`tel:09151251281`}>09151251281</a>
                    <a href={`tel:05136622705`}>05136622705</a>
                  </Stack>
                }
              />
            </Stack>
            <Divider w={'100%'} display={{ lg: 'none' }} />
            <Box>
              <Text fontSize={'small'}>
                ما را در شبکه های اجتماعی دنبال کنید
              </Text>
              <Stack
                direction={'row'}
                fontSize={'lg'}
                spacing={4}
                justify={'center'}
                mt={2}
              >
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.instagram.com/pintora.ir"
                >
                  <BiLogoInstagram />
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://t.me/pintora_ir"
                >
                  <BiLogoTelegram />
                </a>
              </Stack>
            </Box>
            <Divider w={'100%'} display={{ lg: 'none' }} />
            <Stack gap={2}>
              <QuickLink href="/terms">شرایط و قوانین</QuickLink>
              <QuickLink href="/faq">سوالات متداول</QuickLink>
            </Stack>
            <Link to={'/contact-us'}>
              <Image
                alt="نشان اعتماد الکترونیکی"
                src="/assets/icons/enamad-placeholder.png"
                w={'80px'}
              />
            </Link>
          </Stack>
        </Stack>
      </Container>
    </footer>
  );
}

function QuickLink({ children, href }) {
  return (
    <Text
      as="h2"
      display={'flex'}
      alignItems="center"
      gap={2}
      color="#555"
      fontSize={'small'}
      fontWeight={'bold'}
    >
      <FaCheckDouble size={14} />
      <Link to={href}>{children}</Link>
    </Text>
  );
}

function InfoItem({ icon: Icon, title, value }) {
  return (
    <Stack
      direction={{ base: 'column', sm: 'row' }}
      fontSize={'small'}
      spacing={{ base: 2, sm: 4 }}
      align={'flex-start'}
    >
      <Stack direction={'row'} fontWeight={'bold'}>
        <Icon size={16} style={{ display: 'inline-block' }} />
        <span>{title}</span>
      </Stack>
      <Text>{value}</Text>
    </Stack>
  );
}

export default Footer;
